import { IMediumAttributes } from '../IMedium';

export interface IMediaFileType {
  file_type?: 'image' | 'video' | 'audio' | 'document';
}

const customOrder: string[] = ['Image', 'Video', 'Audio', 'Document'];

const orderLookup = customOrder.reduce<{ [key: string]: number }>((acc, type, index) => {
  return { ...acc, [type]: index };
}, {});

export const customSort = (a: IMediumAttributes, b: IMediumAttributes): number => {
  const orderA =
    orderLookup[a.medium?.file_type || a.medium?.data?.attributes?.file_type] !== undefined
      ? orderLookup[a.medium?.file_type || a.medium?.data?.attributes?.file_type]
      : customOrder.length;
  const orderB =
    orderLookup[b.medium?.file_type || b.medium?.data?.attributes?.file_type] !== undefined
      ? orderLookup[b.medium?.file_type || b.medium?.data?.attributes?.file_type]
      : customOrder.length;
  return orderA - orderB;
};
